import React from 'react';
import { Typography, Box } from '@mui/material';
import PointWithIcon from '../PointWithIcon/PointWithIcon';
import styles from './styles';

function List({ list, size = 'default', iconColor }) {
  return (
    <Typography component="ul" sx={styles.list}>
      {list.map((item, index) => (
        <Box key={index} component="li" sx={styles[`listItem_${size}`]}>
          <PointWithIcon iconColor={iconColor} size={size}>
            <Typography
              component="span"
              variant="desktopP2"
              sx={styles[`itemText_${size}`]}
            >
              {item}
            </Typography>
          </PointWithIcon>
        </Box>
      ))}
    </Typography>
  );
}

export default List;
